export const Product2Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 6.35309V15.647C19 15.8649 18.8819 16.0656 18.6914 16.1715L10.2914 20.8381C10.1102 20.9388 9.88982 20.9388 9.70862 20.8381L1.30863 16.1715C1.11816 16.0656 1.00002 15.8649 1.00002 15.647L1 6.35309C1 6.13519 1.11814 5.93442 1.30862 5.8286L9.70862 1.16193C9.88982 1.06126 10.1102 1.06126 10.2914 1.16193L18.6914 5.8286C18.8818 5.93442 19 6.13519 19 6.35309Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M1.5293 6.29363L9.70946 10.8382C9.89066 10.9389 10.1111 10.9389 10.2923 10.8382L18.5009 6.27783"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M10 20V11"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <circle cx="16" cy="3.5" r="3" fill="black" />

    <text
      x="16"
      y="4.6"
      text-anchor="middle"
      font-size="4"
      fill="white"
      font-family="Arial, Helvetica, sans-serif"
      font-weight="bold"
    >
      2
    </text>
  </svg>
);
